import React from 'react';
import './Hero.css';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="market-label">
        What is "Emic"?
      </div>
      <h1 className="hero-title">
        The Power of the <span className="highlight">Insider's</span> View
      </h1>
      <p className="hero-description">
        "Emic" is a term used to describe an understanding of a culture from the perspective of an insider. It’s a viewpoint that can only be earned through experience, fluency, and deep, human connection.
      </p>
      <p className="hero-description">
        We believe that true market entry success comes from this kind of insight. Our work goes beyond surface-level trends and generic market reports. We uncover the unspoken rules, cultural nuances, and authentic desires that only an insider can perceive.
      </p>
      <div className="hero-buttons">
        <a className="cta-btn primary schedule-top-btn" href="#contact-section" >Chat With Us</a>
        {/* <a  href="#gateway-section">View Offerings</a> */}
                <Link className="cta-btn secondary offerings-btn" to="/blogs">Our Blog</Link>
      </div>
    </section>
  );
};

export default Hero;